<template>

<div class="item" v-bind:class="{'is-selectable': selectable, 'is-dark': dark}">

	<core-avatar :type="(type === 'player') ? 'player' : 'user'" :notLinked="notLinked" :item="item" class="item-avatar" v-on:click="onAvatarClick" />

	<core-avatar type="game" :id="item.game" :tooltip="true" class="item-game" v-if="item.game" />

	<div class="item-name">

		<app-router v-if="!notLinked && !cantLink" :to="{name: 'Collection', params: {type: 'users', name: item.username || item.name}}" class="item-name-name">{{ overrideName || name }}</app-router>

		<app-router v-if="isPlayer && !notLinked" :to="{name: 'InsightsPlayer', params: {player: item.slug}}" class="item-name-name" v-tooltip.left="'Click to view player profile'">{{ overrideName || name }}</app-router>

		<div v-if="(notLinked || cantLink) && (!isPlayer || notLinked)" class="item-name-name">{{ overrideName || name }}</div>

		<div class="item-name-tag" :data-theme="tagTheme" v-if="tag"><span>{{ tag }}</span></div>

		<div class="item-name-subtext" v-if="username && !subtext && !subdate && !tag">{{ username }}</div>

		<div class="item-name-subtext" v-if="subtext">{{ subtext }}</div>

		<div class="item-name-subtext" v-if="subdate">{{ subdateFinal }} {{ item.date | formatDate('Do MMMM YYYY') }}</div>

	</div>

	<slot></slot>

	<core-rating v-if="rating" :value="rating" class="item-rating" />

	<div v-if="item[countFieldFinal] && !countPercent" class="item-count" v-fit>{{ item[countFieldFinal] | prettyNumber }}<small v-if="countText">{{ countText }}<template v-if="item.count !== 0">s</template></small></div>

	<core-progress :percent="item[countFieldFinal]" v-if="item[countFieldFinal] && countPercent" :dark="dark" /> 

	<div v-if="selectable" class="item-selectable"><i class="fa fa-caret-right"></i></div>

</div>

</template>

<script>

export default {

	props: ['item', 'type', 'subtext', 'countText', 'countField', 'tag', 'tagTheme', 'overrideName', 'countPercent', 'subdate', 'notLinked', 'selectable', 'rating', 'dark'],

	computed: {

		countFieldFinal: function() {

			return this.countField || 'count'

		},

		subdateFinal: function() {

			var subdate = this.subdate

			if (this.item.game) {

				subdate = subdate.replace(':game', this.$store.getters['data/games/associated'][this.item.game].name)

			}

			return subdate

		},

		cantLink: function() {

			return !this.item.id || this.type === 'player'

		},

		isPlayer: function() {

			return this.type === 'player'

		},

		name: function() {

			return this.item.fullname || this.item.name

		},

		username: function() {

			return (this.item.fullname) ? this.item.name : this.item.username

		}

	},

	methods: {

		onAvatarClick: function() {

			if (this.isPlayer && !this.notLinked) {

				this.$router.push({
					name: 'InsightsPlayer', 
					params: {
						player: this.item.slug
					}
				})

			}

		}

	}

}

</script>

<style scoped>

.item {
	width: 100%;
	height: 64px;
	display: flex;
	padding: 8px 15px 8px 15px;
	flex-direction: row;
}

@media only screen and (max-width: 767px) {

	.item {
		padding: 8px 8px;
		height: auto;
	}

}

.item:nth-child(odd) {
	background-color: rgba(12, 137, 178, 0.05);
}

.item.is-dark:nth-child(odd) {
	background-color: rgba(255, 255, 255, 0.05);
}

.is-desktop .item.is-selectable:hover {
	cursor: pointer;
	background-color: #4881bb;
}

.is-desktop .item.is-dark.is-selectable:hover {
	background-color: rgba(0, 0, 0, 0.2);
}

.item-game,
.item-avatar {
	width: 48px;
	height: 48px;
	flex-shrink: 0;
}

.item-game {
	margin-left: 8px;
}

.item-name {
	padding: 0px 8px;
	flex-grow: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.item-name-name {
	font-size: 16px;
    line-height: 16px;
    font-weight: 400;
    color: #333;
    overflow: hidden;
    display: block;
}

.item.is-dark .item-name-name {
	color: #fff;
}

@media only screen and (max-width: 767px) {

	.item-name-name {
		font-size: 14px;
	}

}

.is-desktop .item.is-selectable:hover .item-name-name {
	color: #fff;
}

.item-name-subtext {
	font-size: 11px;
	color: #666;
}

.item.is-dark .item-name-subtext {
	color: rgba(255, 255, 255, 0.75);
}

.is-desktop .item.is-selectable:hover .item-name-subtext {
	color: #fff;
}

.is-desktop .item-name a:hover {
	text-decoration: underline;
	cursor: pointer;
}

.item-selectable {
	line-height: 64px;
	width: 64px;
	text-align: center;
	position: absolute;
	right: 0px;
	top: 0px;
	font-size: 32px;
	opacity: 0.75;
}

.item.is-dark .item-selectable {
	color: #fff;
}

.is-desktop .item.is-selectable:hover .item-selectable {
	color: #fff;
	opacity: 1;
}

.item-rating {
	flex-shrink: 0;
	width: 48px;
	height: 48px;
	line-height: 48px;
	font-size: 18px;
	font-weight: 400;
}

.item-count {
	height: 48px;
	width: 48px;
    flex-shrink: 0;
    font-size: 24px;
    font-weight: 400;
    color: #333;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
}

.item-count:not(.is-percent) {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
}

.item.is-dark .item-count {
	color: #fff;
}

@media only screen and (max-width: 767px) {

	.item-count {
		font-size: 18px;
	}

}

.item-count small {
	font-size: 11px;
	color: #666;
	display: block;
}

.item.is-dark .item-count small {
	color: rgba(255, 255, 255, 0.75);
}

.item-name-tag {
	margin-top: 2px;
}

.item-name-tag span {
	display: inline-block;
	color: #333;
	font-weight: 400;
	font-size: 12px;
	border-radius: 4px;
	padding: 2px 4px;
}

.item-name-tag[data-theme="green"] span {
	background-color: #3bce5a;
}

.item-name-tag[data-theme="blue"] span {
	background-color: #8FC0D4;
}

</style>